import { useEffect } from "react";

const AdsterraNativeBanner = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://bauval.org/21/eb066f644313c36c26fa319f0f38604f";
    script.async = true;
    script.setAttribute("data-cfasync", "false");

    const container = document.getElementById(
      "container-eb066f644313c36c26fa319f0f38604f"
    );

    if (container) {
      container.innerHTML = "";
      container.appendChild(script);
    }

    return () => {
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);

  return (
    <div
      id="container-eb066f644313c36c26fa319f0f38604f"
      className="w-full"
    />
  );
};

export default AdsterraNativeBanner;